import React, {Component} from "react";
import {
    Badge,
    Row,
    Col,
    Alert,
    Progress,
    Dropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    Card,
    CardHeader,
    CardBody,
    CardFooter,
    CardTitle,
    Button,
    ButtonToolbar,
    ButtonGroup,
    ButtonDropdown,
    Label,
    Input,
    Table
} from "reactstrap";
import Map from "./Map";
import LoadingIndicator from '../../utils/LoadingIndicator';
import Siteslist from '../../components/Sitelist/Siteslist';
import Pendingnotifications from '../../components/Sitelist/Pendingnotifications';
import WhatsNew from '../../components/WhatsNew/WhatsNew';

class Dashboard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            newNotification: false,
            loading: true
        };
    }
    componentDidMount() {
        this.setState({
            loading: false
        })

    }

    newNotification = (data) => {
        if (!this.state.newNotification && data >= 1) {
            this.setState({ newNotification: true });
        }
    };

    render() {
        if (this.state.loading || (this.props.uidata.alarms === undefined)) {
            return <LoadingIndicator />;
        }
        let { alarms } = this.props.uidata;
        console.log(this.props.uidata.alarms.length);
        return (
            <div className="containerAnimation">
            <div className="fadeInUp">
                {this.state.newNotification ?
                <Row>
                    <Col xs="12" lg="12">
                        <Alert color="warning">
                            You have a new site invitation, <a href="#/account" className="alert-link">click here</a> for more information. You can view, accept or reject new invitations below or by navigating to your account page page.
                        </Alert>
                    </Col>
                </Row>
                    : "" }

                                <WhatsNew/>
                {(this.props.uidata.alarms.length >= 1) && (
                    <Row>
                        <Col xs="12" lg="12">
                            <Card>
                                <CardBody className="card-body">
                                    <Map sites={this.props.uidata.alarms} goToSite={(siteUrl) => this.props.goToSite(siteUrl)}/>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                )}
                <Row>
                    <Col xs="12" lg="12">
                        <Card>
                            <CardBody className="card-body">
                                <Row className="pb-2">
                                    <Col sm="12">
                                        <CardTitle className="mb-1">Sites</CardTitle>
                                        <div className="small text-muted">current list of sites you have permission to access</div>
                                    </Col>
                                </Row>
                                <Row className="pb-2">
                                    <Col sm="12">
                                        {alarms !== undefined ? <Siteslist sites={this.props.uidata.alarms} goToSite={(siteUrl) => this.props.goToSite(siteUrl)}/> : ""}
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
                <Row>
                    <Col xs="12">
                        <Card>
                            <CardBody className="card-body">
                                <Row className="pb-4">
                                    <Col sm="10">
                                        <CardTitle className="mb-1">Pending Site Invites</CardTitle>
                                        <div className="small text-muted">view and accept pending site information</div>
                                    </Col>
                                    <Col sm="2" className="d-none d-sm-inline-block">
                                        <i className="fa fa-hourglass-end float-right text-secondary"></i>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm="12">
                                        <Pendingnotifications checkForNewNotifications={this.newNotification} reloadNavBar={() => this.props.reloadNavBar()}/>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>
            </div>
        )
    }
}

export default Dashboard;



// WEBPACK FOOTER //
// ./src/views/Dashboard/Dashboard.js